<nz-layout>
  <nz-header class="section-header">
    {{'Medical History'|translate}}
  </nz-header>
  <nz-content>
    @for (cm of submenu; track cm) {
      @if (cm.path==componentPaths.vaccinations) {
        <app-vaccination [id]="cm.path" />
      }
      @if (cm.path==componentPaths.resolvedProblems) {
        <app-resolved-problems [id]="cm.path" />
      }
      @if (cm.path==componentPaths.medicalHistory) {
        <app-medical-history [id]="cm.path" />
      }
    }
  </nz-content>
</nz-layout>